<template>
	<div>
		<table class="strapi-table">
			<StrapiSortableHeader v-if="sortable" :columns="columns" />
			<StrapiTableHeader v-else :columns="columns" />
			<tbody ref="body">
				<slot />
			</tbody>
		</table>
		<div v-if="loading" class="load" :style="loadHeight">
			<loading />
		</div>
		<div v-else-if="!items.length" class="status">
			<p>Nothing to see here!</p>
		</div>
		<StrapiPagination v-if="showPagination" :count="count" />
	</div>
</template>

<script>
import Loading from '@/components/shared/Loading'
import StrapiSortableHeader from '@/components/admin/StrapiSortableHeader'
import StrapiTableHeader from '@/components/admin/StrapiTableHeader'
import StrapiPagination from '@/components/admin/StrapiPagination'

export default {
	name: 'StrapiTable',
	data() {
		return {
			height: 0
		}
	},
	props: {
		loading: Boolean,
		items: Array,
		count: Number,
		columns: {
			type: Array,
			validator: v => v.every(i => i.column || i.label)
		},
		sortable: {
			type: Boolean,
			default: true
		},
		pagination: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		loadHeight() {
			return {
				height: this.height + 'px'
			}
		},
		showPagination() {
			return this.pagination && this.count > 0
		}
	},
	watch: {
		loading(loading) {
			if (loading && this.$refs.body) {
				this.height = this.$refs.body.getBoundingClientRect().height
			}
		}
	},
	components: {
		Loading,
		StrapiSortableHeader,
		StrapiTableHeader,
		StrapiPagination
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/layout';

.load {
	position: relative;
	min-height: 8rem;
}

.status {
	@extend %flex-center;
	position: relative;
	min-height: 8rem;
}
</style>

<style lang="scss">
@import '~scss/components';
.strapi-table {
	@extend %table;
}
</style>
